import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader, getUserParam } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import { covertPhoneNumVietNam } from "app/shared/util/validate";
import { DataTransferCreate } from "../../reducer/types";
import {
  FetchTransferLocalAccountDetailRequest,
  FetchTransferLocalAuthorizationRequest,
  FetchTransferLocalConfirmRequest,
} from "../reducer/types";

const createParam = (dataCreate: DataTransferCreate): REQUESTINPUT => {
  const state = store.getState();
  const listAccount = state.account.LIST_ACCOUNT_PROFILE?.ACCOUNT;
  let serviceCode = ServiceCode.TRANSFER_LOCAL_OTHER_CIF;
  const checkSameCif = listAccount?.filter((item) => {
    return item.ACCOUNTNO === dataCreate.ACCOUNT_CREDIT?.ACCOUNTNO;
  });
  if (checkSameCif && checkSameCif.length) {
    serviceCode = ServiceCode.TRANSFER_LOCAL_SAME_CIF;
  }
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      FEE_TYPE: dataCreate.FEE_TYPE,
      SERVICE_CODE: serviceCode,
      CREDIT_ACCOUNT_NAME: dataCreate.ACCOUNT_CREDIT?.ACCOUNTNAME,
      CREDIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_CREDIT?.ACCOUNTNO,
      CREDIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_CREDIT?.ACCOUNTTYPE,
      CREDIT_BANK_NAME: dataCreate.ACCOUNT_CREDIT?.BANK_NAME || "",
      CREDIT_BRANCH_NAME: dataCreate.ACCOUNT_CREDIT?.BRANCH_NAME || "",
      DEBIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      DEBIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
      TRANSACTION_AMOUNT: dataCreate.AMOUNT,
      TRANSACTION_DESCRIPTION: dataCreate.DESCRIPTION,
      TRANSACTION_POSTING: "UPDATE",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

const confirmParam = (action: FetchTransferLocalConfirmRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      ...action.payload?.TRANSFER,
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

const authParam = (action: FetchTransferLocalAuthorizationRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    AUTHORIZE_CODE: action.code,
    CHALLENGE_ID: action.payload?.CHALLENGE_ID,
    USERPROFILE: getUserHeader(),
    TRANSFER: {
      RQSTSEQ: action.payload?.TRANSFER?.RQSTSEQ || "",
      TRANSACTION_POSTING: action.payload?.TRANSFER?.TRANSACTION_POSTING || "UPDATE",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

export const fetchTransferLocalCreateService = async (dataCreate: DataTransferCreate) => {
  const params: REQUESTINPUT = createParam(dataCreate);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CIF_TRANSFER);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

// Xác nhận chuyển tiền
export const fetchTransferLocalConfirmService = async (actionRq: FetchTransferLocalConfirmRequest) => {
  const params: REQUESTINPUT = confirmParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_CHECK_TRANSFER_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTransferLocalAuthService = async (actionRq: FetchTransferLocalAuthorizationRequest) => {
  const params: REQUESTINPUT = authParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.TRANS_AUTHORIZE_TRANSFER);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Lấy thông tin chi tiết tk nhận */
export const fetchTransferLocalAccountDetailService = async (actionRq: FetchTransferLocalAccountDetailRequest) => {
  const { action, massageID, url } = ApiPathManager(ApiKey.QUERY_ACCOUNT_DETAIL);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ACCOUNTPROFILE: {
      ACCOUNTNO: actionRq.payload.ACCOUNTNO,
      ACCOUNTTYPE: actionRq.payload.ACCOUNTTYPE,
    },
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

/** Lấy thông tin tk nhận qua sđt */
export const fetchTransferLocalDetailByPhoneService = async (phoneNum: string) => {
  const { url } = ApiPathManager(ApiKey.GET_ACCOUNT_DETAIL_BY_PHONE);
  const signature = store.getState().account.signature;
  const phoneNumConvert = covertPhoneNumVietNam(phoneNum);
  const response: any = await instance.get(url + "/" + phoneNumConvert, { headers: { token: signature } });
  return response;
};
